import React, { Component } from 'react';
import * as axios from "axios/index";
import { Link, Element } from 'react-scroll'

import { Loading } from './parts/Loading';
import lightbox  from "./LightBoxEnable";


function YearBoundary(props) {
  return <Element name={props.year} />
}


function Article(props) {
  const article = props.article;

  let prizeNode = null;
  if (article.meta.prize) {
    prizeNode = <span className="article-prize">{article.meta.prize}</span>;
  }

  let articleSong = null;
  if (article.meta.song !== '') {
    articleSong = (
      <div className="article-song-wrapper clearfix">
        <div className='article-song-label'>曲</div>
        <div className='article-song' dangerouslySetInnerHTML={{__html: article.meta.song}}/>
      </div>
    )
  }

  let articleSongAs = null;
  if(article.meta.song_assignment !== ''){
    articleSongAs = (
      <div className="article-song-wrapper clearfix">
        <div className='article-song-label'>課題曲</div>
        <div className='article-song' dangerouslySetInnerHTML={{__html: article.meta.song_assignment}}/>
      </div>
    )
  }

  let articleSongFr = null;
  if(article.meta.song_free !== ''){
    articleSongFr = (
      <div className="article-song-wrapper clearfix">
        <div className='article-song-label'>自由曲</div>
        <div className='article-song' dangerouslySetInnerHTML={{__html: article.meta.song_free}}/>
      </div>
    )
  }

  return (
    <div key={article.date}>
      <div className='article'>
        <div className='article-header'>
          <div className='article-date'>{article.meta.date}</div>
          <div className='article-title'>{article.title} {prizeNode}</div>
          <div className='article-place'>{article.meta.place}</div>
        </div>
        {articleSong}
        {articleSongAs}
        {articleSongFr}
        <div className='article-content' dangerouslySetInnerHTML={{__html: article.content}}/>
      </div>
    </div>
  )
}


function ArticlesList(props) {
  const ArticlesNode = props.articles.map(article =>  <Article article={article} key={article.date}/>);
  return (
    <div className="article-list">
      <YearBoundary year={props.year}/>
      {ArticlesNode}
    </div>
  )
}


class YearList extends Component {
  constructor(props) {
    super(props);
    this.listRef = React.createRef();
    this.leftRef = React.createRef();
    this.rightRef = React.createRef();
  }

  moveLeft() {
    const curLeft = parseInt(this.listRef.current.style.left.replace("px", ""), 10) || 0;
    const rightLimit = 0;
    if (curLeft < rightLimit )  {
      const newLeft = curLeft + 90;
      this.listRef.current.style.left = newLeft.toString() + "px";

      if (newLeft === rightLimit) {
        this.leftRef.current.classList.add('invisible');
      } else {
        this.rightRef.current.classList.remove('invisible');
      }
    }
  }

  moveRight() {
    const curLeft = parseInt(this.listRef.current.style.left.replace("px", ""), 10) || 0;
    const leftLimit = (this.props.years.length - 10) * -90;

    if (curLeft > leftLimit) {
      const newLeft = curLeft - 90;
      this.listRef.current.style.left = newLeft.toString() + "px";

      if (newLeft === leftLimit) {
        this.rightRef.current.classList.add('invisible');
      } else {
        this.leftRef.current.classList.remove('invisible');
      }
    }
  }

  render() {
    const YearNodes = this.props.years.map(year =>
      <Link to={year} key={year} smooth={true} offset={-140}
            className="year-nav">{year}</Link>
    );

    const listStyle = {
      width: "3000px",
      background: "rgba(240,236,231,.95)"
    };

    return (
      <div className='year-list-wrapper'>
        <div className="content">
          <div className='year-list clearfix'>
            <div className='left-arrow invisible' id='year-left'
                 onClick={this.moveLeft.bind(this)}
                 ref={this.leftRef}>&lt;</div>
            <div className='year-inner-list-wrapper'>
              <div className="year-inner-list clearfix" id='year-inner-list' ref={this.listRef} style={listStyle}>
                {YearNodes}
              </div>
            </div>
            <div className='left-arrow' id='year-right'
                 onClick={this.moveRight.bind(this)}
                 ref={this.rightRef}>&gt;</div>
          </div>
        </div>
      </div>
    )
  }


}

class HistoryComp extends Component {
  constructor(props) {
    super(props);
    this.articles = [];
    this.state = {
      yearArticles: {},
      yearList: [],
      loading_done: false
    }
  }

  loadHistory() {
    let articles = [];

    async function callApi(page) {
      const params = {
        'page': page,
        'filter[posts_per_page]': 10,
        'filter[category_name]': 'history'
      };

      const resp = await axios.get('//midori-frauen.com/wp-json/posts', {params: params})
      articles = articles.concat(resp.data);
      if(resp.data.length === 10) {
        callApi.bind(this)(page + 1);
      } else {
        this.buildYearArticles(articles);
      }
    }
    callApi.bind(this)(1);
  }

  buildYearArticles(articles) {
    let _yearArticles = {};
    let _yearList = [];
    articles.forEach(article => {
      const year = article.meta.date.split('/')[0];
      if (!(year in _yearArticles)) {
        _yearArticles[year] = [];
        _yearList.push(year);
      }
      _yearArticles[year].push(article);
    });

    this.setState({
      yearArticles: _yearArticles,
      yearList: _yearList
    })
  }

  componentDidMount() {
    // TODO: Caching
    this.loadHistory();
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    console.log('unmount');
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const val = window.scrollY;
    const yearList = document.getElementsByClassName('year-list-wrapper')[0];
    const yearListDummy = document.getElementsByClassName('year-list-dummy')[0];

    if (val > 80 && yearList && yearListDummy) {
      yearList.classList.add('fixed');
      yearListDummy.classList.add('active');
    } else {
      if (yearList) {
          yearList.classList.remove('fixed');
          yearListDummy.classList.remove('active');
      }
    }
  }

  render() {
    return (
      <div>
        {this.state.yearList.length > 0 ?
          (
            <div>
              <YearList years={this.state.yearList}/>
              <div className="year-list-dummy"/>
            </div>
          )
           : null}
        <div className="content">
          {this.state.yearList.length > 0 ? (
            this.state.yearList.map(year => {
              return <ArticlesList articles={this.state.yearArticles[year]}
                                   year={year}
                                   key={year}/>
            })
          ) : (
            <Loading/>
          )}

        </div>
      </div>
    )
  }
}

export const History = lightbox(HistoryComp);


// WEBPACK FOOTER //
// ./src/components/History.jsx